var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-whats-share" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "infos" }, [
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("div", { staticClass: "responsible" }, [
        _vm._v(_vm._s(_vm.responsible))
      ]),
      _vm._v(" "),
      _vm.whats
        ? _c(
            "a",
            {
              staticClass: "button whats",
              attrs: { href: _vm.finalLink, target: "_blank", rel: "noopener" }
            },
            [
              _c("img", {
                attrs: {
                  src: "/static/whats-share/whats-icon.svg",
                  alt: "WhatsApp da Donamaid",
                  title: "WhatsApp"
                }
              }),
              _vm._v(" WhatsApp\n    ")
            ]
          )
        : _c(
            "a",
            {
              staticClass: "button fresh",
              attrs: { href: _vm.finalLink, target: "_blank", rel: "noopener" }
            },
            [_vm._v("FreshDesk")]
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image" }, [
      _c("img", {
        attrs: {
          src: "/static/whats-share/iconeswhats-01.png",
          alt: "Dúvidas Donamaid",
          title: "Dúvidas Donamaid"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4d26ef8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4d26ef8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/WhatsShare/Card.vue
// module id = null
// module chunks = 